import React from 'react';
import getTheme from '../constants/themes';

export const Config = () => {
  const hostname = window.location.hostname;
  const theme = getTheme();
  const config = {
    hostname,
    theme
  }
  return (
    <div data-title="Config">
      <pre>
        {JSON.stringify(config, null, 2)}
      </pre>
    </div>
  );
}

export default Config;



// WEBPACK FOOTER //
// ./src/components/Config.jsx